@if (showBanner) {
  <div #banner class="maintenance-banner" role="alert">
    <strong class="maintenance-banner__title">{{ 'scheduled_maintenance' | translate }}</strong>
    <span class="maintenance-banner__message">{{ 'maintenance_message' | translate:{ from: maintenanceFromJst, to: maintenanceToJst } }}</span>
  </div>
}
